import {
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta
} from '@reduxjs/toolkit/query'

type Meta = {}; // eslint-disable-line
type BaseQueryType = BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, Meta, FetchBaseQueryMeta>;

export function baseQueryConfig(apiBasePath: string, opts?: FetchBaseQueryArgs): BaseQueryType {
  return fetchBaseQuery({
    baseUrl: (process.env.REACT_APP_API_URL as string).replace(/\/$/, '') + apiBasePath,
    prepareHeaders: ((headers) => {
      const accessToken = localStorage.getItem('access_token')

      if (accessToken) {
        headers.set('Authorization', `Bearer ${JSON.parse(accessToken)}`)
      }

      return headers
    }),
    ...opts || {}
  })
}
